import { createContext } from 'react';

const PortalsManagerContext = /*#__PURE__*/createContext(undefined);

export { PortalsManagerContext };
